// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SecondaryFooter_Wrapper__1OY68","Text":"SecondaryFooter_Text__1z4pw","Link":"SecondaryFooter_Link__3ZqyS"};